import Nullstack from 'nullstack';
export default function IconMassage({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-massage",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "17",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M4 22l4 -2v-3h12"
  }), "   ", Nullstack.element("path", {
    d: "M11 20h9"
  }), "   ", Nullstack.element("path", {
    d: "M8 14l3 -2l1 -4c3 1 3 4 3 6"
  }), " ");
}